import { Component, ElementRef, HostBinding, HostListener, ViewChild } from '@angular/core';
import { PwLocaleService } from '@pw-utils/services/locale/locale.service';

@Component({
  selector: 'pw-language-select',
  templateUrl: './language-select.component.html',
  styleUrls: ['./language-select.component.scss'],
})
export class LanguageSelectComponent {
  private _optionsWrapper: ElementRef<HTMLDivElement>;

  @ViewChild('optionsWrapper')
  public get optionsWrapper(): ElementRef<HTMLDivElement> {
    return this._optionsWrapper;
  }

  public set optionsWrapper(value: ElementRef<HTMLDivElement>) {
    this._optionsWrapper = value;
    setTimeout(() => this._setFirstAsSelected());
  }

  @HostBinding('tabindex') public tabindex = 0;
  public isSelectionOpen = false;
  public selected: HTMLElement;
  private _isInnerClick = false;
  private _isBlurred = false;

  constructor(public locale: PwLocaleService) {}

  @HostListener('focusout')
  public onBlur(): void {
    setTimeout(() => this._isBlurred && (this.isSelectionOpen = false));
    this._isBlurred = true;
  }

  @HostListener('focusin')
  public onFocus(): void {
    this._isBlurred = false;
  }

  @HostListener('keydown.enter')
  public onEnter(): void {
    if (this.isSelectionOpen) this.selected?.click();
    else this.isSelectionOpen = true;
  }

  @HostListener('keydown.arrowUp')
  public onArrowUp(): void {
    this.isSelectionOpen = true;
    this._changeSelectedOption(-1);
  }

  @HostListener('keydown.arrowDown')
  public onArrowDown(): void {
    this.isSelectionOpen = true;
    this._changeSelectedOption(1);
  }

  @HostListener('click')
  public onClick(): void {
    if (!this._isBlurred) this.isSelectionOpen = !this.isSelectionOpen;
    this._isInnerClick = true;
  }

  @HostListener('window:click')
  public onOutsideClick(): void {
    if (!this._isInnerClick) this.isSelectionOpen = false;
    this._isInnerClick = false;
  }

  private _setFirstAsSelected(): void {
    this.selected = this.optionsWrapper?.nativeElement?.querySelectorAll('.lang-list-option')[0] as HTMLElement;
  }

  private _changeSelectedOption(increment: number): void {
    if (!this._optionsWrapper) return;
    const options = Array.from(this._optionsWrapper?.nativeElement?.querySelectorAll('.lang-list-option'));
    const selectedIndex = options.findIndex((item) => item.classList.contains('selected')) ?? 0;
    const nextIndex = (options.length + selectedIndex + increment) % options.length;
    options[selectedIndex]?.classList.remove('selected');
    options[nextIndex]?.classList.add('selected');
    this.selected = options[nextIndex] as HTMLElement;
  }
}
